import { Statuses } from '@wix/domains-search-suite';
import { MobileConnectOnDesktop } from '../../Components/StatusesOverrides/LoggedInMobile/MobileConnectOnDesktop';
const upgradeRequireAssignStatus = props => ({
  ...Statuses.upgradeRequireAssign(props),
  StatusComponent: MobileConnectOnDesktop,
  autoInvoke: false
});
export const mobileUpgradeRequireAssignStatus = upgradeRequireAssignStatus;
//# sourceMappingURL=mobileUpgradeAssignStatus.js.map